import { render, staticRenderFns } from "./DepartmentDocumentsPrint.vue?vue&type=template&id=84f0794a&"
import script from "./DepartmentDocumentsPrint.vue?vue&type=script&lang=js&"
export * from "./DepartmentDocumentsPrint.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentDocumentsPrint.vue?vue&type=style&index=0&id=84f0794a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports